// Friendly empty state used inside tables and content cards.

export default function EmptyState({ icon, title, description, action }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-10 px-4">
      {icon ? (
        <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-50 text-brand-500 text-2xl mb-4">
          {icon}
        </span>
      ) : null}
      {title ? (
        <h3 className="text-base font-semibold text-ink-900 m-0">{title}</h3>
      ) : null}
      {description ? (
        <p className="text-sm text-ink-500 mt-1 mb-0 max-w-sm">{description}</p>
      ) : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
